import { api } from './client';
import type {
  CategoryWiseRow,
  ConsolidatedReport,
  DailyReport,
  PaymentRow,
  ProductWiseRow,
  StoreWiseRow,
  TaxReport,
} from '../types';

export interface RangeQuery {
  from?: string;
  to?: string;
  storeId?: number | null;
}

export const reportsApi = {
  daily: (storeId: number | null | undefined, date: string) =>
    api
      .get<DailyReport>('/reports/daily', {
        params: { storeId: storeId ?? undefined, date },
      })
      .then((r) => r.data),

  consolidated: (date: string) =>
    api
      .get<ConsolidatedReport>('/reports/consolidated', { params: { date } })
      .then((r) => r.data),

  storeWise: (q: RangeQuery) =>
    api
      .get<StoreWiseRow[]>('/reports/store-wise', {
        params: {
          from: q.from || undefined,
          to: q.to || undefined,
          storeId: q.storeId ?? undefined,
        },
      })
      .then((r) => r.data),

  productWise: (q: RangeQuery) =>
    api
      .get<ProductWiseRow[]>('/reports/product-wise', {
        params: {
          storeId: q.storeId ?? undefined,
          from: q.from || undefined,
          to: q.to || undefined,
        },
      })
      .then((r) => r.data),

  categoryWise: (q: RangeQuery) =>
    api
      .get<CategoryWiseRow[]>('/reports/category-wise', {
        params: {
          storeId: q.storeId ?? undefined,
          from: q.from || undefined,
          to: q.to || undefined,
        },
      })
      .then((r) => r.data),

  payment: (q: RangeQuery) =>
    api
      .get<PaymentRow[]>('/reports/payment', {
        params: {
          storeId: q.storeId ?? undefined,
          from: q.from || undefined,
          to: q.to || undefined,
        },
      })
      .then((r) => r.data),

  tax: (q: RangeQuery) =>
    api
      .get<TaxReport>('/reports/tax', {
        params: {
          storeId: q.storeId ?? undefined,
          from: q.from || undefined,
          to: q.to || undefined,
        },
      })
      .then((r) => r.data),
};
